<template>
    <div class="vimeactivityassistancenewform">
        <div class="container">
            <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading>
            <br>
            <br>
            <div v-if='isActivityAssistancesInfoEmpty'>
                <div class="columns is-centered">
                    <h4 class="title is-4">
                        Esta actividad no presenta un registro de invitados, haga click <a @click="newActivityAssistant()">Aquí</a> para añadir un nuevo invitado.
                    </h4>
                </div>
            </div>
            <div v-else>
                <div class="columns">
                    <div class="column">
                        <h1 class="title">Lista de invitados</h1>
                    </div>
                    <div class="column">
                        <div class="field is-grouped is-grouped-right">
                            <div class="control">
                                <button class="button is-primary" @click="newActivityAssistant()">
                                    <b-icon icon="plus"></b-icon>
                                    <span>Añadir un nuevo participante</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <b-table
                    :data="getGeneralAssistance"
                    :paginated=true
                    per-page=10
                    striped
                    hoverable
                    :current-page="currentPage"
                    :pagination-simple=false
                    pagination-position="bottom"
                    default-sort-direction="asc"
                    sort-icon="arrow-up"
                    sort-icon-size="is-small"
                    default-sort="publication.title"
                    aria-next-label="Siguiente"
                    aria-previous-label="Anterior"
                    aria-page-label="Página"
                    aria-current-label="Página actual"
                    header-class="is-primary">
                    <b-table-column 
                        label= 'Nombre'
                        centered
                        v-slot="props"
                        header-class="is-primary">
                        {{props.row.person_name}}
                    </b-table-column>
                    <b-table-column 
                        label= 'RUT'
                        centered
                        v-slot="props"
                        header-class="is-primary">
                        {{props.row.rut}}
                    </b-table-column>
                    <b-table-column 
                        label= 'Asiste como'
                        centered
                        v-slot="props"
                        header-class="is-primary">
                        {{props.row.assistance_type_name}}
                    </b-table-column>
                    <b-table-column centered header-class="is-primary" v-slot="props">
                        <button class="button is-danger" @click="confirmActivityAssistantDelete(props.row)">
                            <b-icon icon="times"></b-icon>
                            <span>Eliminar</span>
                        </button>
                    </b-table-column>
                </b-table>
            </div>
            <br>
            <div class="field is-grouped is-grouped-right">
                <div class="control">
                    <button class="button is-link is-primary" @click="back()">Volver</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import VimeActivityAssistanceNewModal from './vime_activity_assistance_new_modal.vue'
export default {
    name: 'VimeActivityAssistanceNewForm',
    props:{
        vime_activity_id:{
            type: Number
        }
    },
    data() {
        return {
            currentPage:1,
            isFullPage: true,
            isLoading: true,
            generalAssistance: [],
            modalAssistance: [],
            modalAssistanceTypes: [],
            validations:{
                chargingGeneralInformation: true
            }
        }
    },
    computed:{
        isActivityAssistancesInfoEmpty(){
            return Object.entries(this.generalAssistance).length === 0
        },
        getGeneralAssistance(){
            return this.generalAssistance
        }
    },
    beforeMount(){
        this.getVimeActivityAssistance()
        this.getAssistancesToModal()
        this.getAssistancesTypesToModal()
    },
    methods:{
        getVimeActivityAssistance(){
            axios.get('/vime_activity_assistances/getAssistanceByActivityId/'+this.vime_activity_id)
            .then(response =>{
                this.generalAssistance = response.data.assistance
            })
            .catch(e => { 
                console.log(e)
            })
        },
        getAssistancesToModal(){
            axios.get('/activity_assistances/getAssistancesToModal')
            .then(response =>{
                this.modalAssistance = response.data.assistance
                this.isLoading=false
            })
            .catch(e => {
                console.log(e)
            })
        },
        getAssistancesTypesToModal(){
            axios.get('/vime_assistant_types/get_assistants_types/0.json')
            .then(response =>{
                this.modalAssistanceTypes = response.data
                this.isLoading=false
            })
            .catch(e => {
                console.log(e)
                this.isLoading=false
            })
        },
        newActivityAssistant(){
            this.$buefy.modal.open({
                parent: this,
                component: VimeActivityAssistanceNewModal,
                props:{
                    'vime_activity_assistances_info': this.modalAssistance,
                    'vime_assistant_types': this.modalAssistanceTypes
                },
                hasModalCard: true,
                events:{
                    'add-assistant': this.addNewAssistance
                },
                customClass: 'is-primary',
                trapFocus: true
            })
        },
        addNewAssistance(newAssistance){
            this.isLoading=true
            console.log(newAssistance)
            var addPersonLikeNewAssistant = true
            this.generalAssistance.forEach(function(element){
                if(element.person_name === newAssistance.person_name)
                    addPersonLikeNewAssistant = false
            })
            if(addPersonLikeNewAssistant){
                axios.post('/vime_activity_assistances.json', {
                    'description': ' ',
                    'run_id': newAssistance.run_id, 
                    'vime_assistant_type_id': newAssistance.assistance_type_id,
                    'vime_activity_id': this.vime_activity_id
                })
                .then( response =>{
                    console.log(response.data)
                    var newData = newAssistance
                    newData.id = response.data.id
                    this.generalAssistance.push(newData)
                    this.isLoading=false
                })
                .catch(e => {
                    console.log(e)
                    this.isLoading=false
                })
            }
            else{
                this.isLoading=false
                this.$buefy.dialog.alert({
                    title: 'Advertencia: Invitado ya agregado.',
                    message: 'El invitado que tratas de añadir ya existe.',
                    confirmText: 'Aceptar'
                })
            }
        },
        confirmActivityAssistantDelete(deleteActivityAssistantType){
            this.$buefy.dialog.confirm({
                title: 'Eliminación de un asistente',
                message: '¿Quieres eliminar al asistente: <b>'+deleteActivityAssistantType.person_name+'</b>? este cambio no puede deshacerse.',
                confirmText: 'Eliminar',
                cancelText: 'Cancelar',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteAssistance(deleteActivityAssistantType.id)
            })
        },
        deleteAssistance(id){
            axios.delete('/vime_activity_assistances/'+id+'.json')
            .then( response =>{
                console.log(response.data)
                this.generalAssistance = this.generalAssistance.filter(
                    element => element.id !== id
                )
                this.$buefy.toast.open({
                    message: 'Asistente a actividad eliminado correctamente.',
                    type: 'is-primary'
                })
            })
            .catch(e => {
                console.log(e)
            })
        },
        back(){
            this.isLoading = true
            window.location.href='/vime_activities/'+this.vime_activity_id
        }
    }
}
</script>